import dayjs from 'dayjs';

export default function postDateFormat(
  date: string | Date | dayjs.Dayjs | undefined
) {
  if (date) {
    return dayjs(date).format('YYYY-MM-DD');
  } else return undefined;
}
